import React, { useEffect, useState } from 'react'
import { collection, query, where, getDocs } from 'firebase/firestore'
import { db } from '../../firebase'
import { useSchoolId } from '../../lib/auth/schoolContext'
import { useStudents } from '../../lib/useStudents'
import { getSencoProvisionOverview } from '../../lib/functions'

export default function DashboardStats() {
  const { schoolId } = useSchoolId()
  const { students } = useStudents()
  const [activeInterventions, setActiveInterventions] = useState(0)
  const [provisionSummary, setProvisionSummary] = useState({
    waitlistTotal: null,
    missingProvisionStudentCount: null,
    loading: true,
  })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!schoolId) return

    const fetchStats = async () => {
      setLoading(true)
      setProvisionSummary((prev) => ({ ...prev, loading: true }))
      try {
        const [interventionsSnap, overviewResult] = await Promise.all([
          getDocs(
            query(
              collection(db, 'interventions'),
              where('schoolId', '==', schoolId),
              where('status', '==', 'active')
            )
          ),
          getSencoProvisionOverview({}).catch(() => ({ data: null })),
        ])

        setActiveInterventions(interventionsSnap.size)
        const summary = overviewResult?.data?.summary
        setProvisionSummary({
          waitlistTotal: summary?.waitlistTotal ?? 0,
          missingProvisionStudentCount: summary?.missingProvisionStudentCount ?? 0,
          loading: false,
        })
      } catch (error) {
        console.error('Error fetching dashboard stats:', error)
        setProvisionSummary((prev) => ({ ...prev, loading: false }))
      } finally {
        setLoading(false)
      }
    }

    fetchStats()
  }, [schoolId])

  const statsLoading = loading || provisionSummary.loading

  const stats = [
    {
      label: 'On waitlist',
      value: statsLoading ? '…' : provisionSummary.waitlistTotal,
      color: 'text-purple-600',
      bg: 'bg-purple-50',
    },
    {
      label: 'Section F gaps',
      value: statsLoading ? '…' : provisionSummary.missingProvisionStudentCount,
      color: 'text-amber-600',
      bg: 'bg-amber-50',
    },
    {
      label: 'Active Interventions',
      value: statsLoading ? '…' : activeInterventions,
      color: 'text-emerald-600',
      bg: 'bg-emerald-50',
    },
    {
      label: 'Total Students',
      value: students.length || 0,
      color: 'text-blue-600',
      bg: 'bg-blue-50',
    },
  ]

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 p-4 bg-gray-50/50 border-t border-gray-100">
      {stats.map((stat) => (
        <div key={stat.label} className={`${stat.bg} rounded-xl px-4 py-3 text-center`}>
          <span className={`text-2xl font-bold ${stat.color}`}>{stat.value}</span>
          <p className="text-sm text-gray-600 mt-0.5">{stat.label}</p>
        </div>
      ))}
    </div>
  )
}
